export default __webpack_public_path__ + "static/media/galletas-super.87e8cf27.jpg";